/// <amd-module name="CodeCoverage/CodeCoverageTab/Stores/CodeCoverageMessagesMap" />
import * as Resources from 'CodeCoverage/CodeCoverageTab/Resources';

export class CodeCoverageMessagesMap{
    public static codeCoverageFailureMap= new Map<string,string>([
      ["5",Resources.NoCodeCoverageFound],
      ["6", Resources.NumberOfFilesExceeded],
      ["7",Resources.NoInputFiles],
      ["8",Resources.BuildCancelled],
      ["10",Resources.ModuleMergeJobTimeout],
      ["14",Resources.FailedToRequeue],
      ["16",Resources.CodeCoverageNotConfigured],
      ["18",Resources.CoverageMergeJobFailed],
      ["20",Resources.ModuleMergeInvokerJobTimeout],
      ["21",Resources.MonitorJobTimeout],
      ["22",Resources.InvalidCoverageInput]
  ]);
}
